import Immutable from 'immutable';
import { DateTime, Duration } from 'luxon';

const ThumbnailRecord = Immutable.Record({
  square: '',
  small: '',
  original: '',
  time: DateTime.local(),
});

export interface ThumbnailArgs {
  square: string;
  small: string;
  original: string;
  time: DateTime | Duration;
}

interface Thumbnail extends ThumbnailArgs {}

class Thumbnail extends ThumbnailRecord {
  constructor(args?: ThumbnailArgs) {
    super(args ?? {});
  }
}

export default Thumbnail;
